import { get } from 'lodash';
import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import { withAmp } from '../AMP/AmpContext';

class VideoInContext extends Component {
  render () {
    const { amp, video, options } = this.props;

    // Get Thumbnail
    const thumbnailImage = get((video.thumbnailImage || []).find(tn => tn.aspectRatio === '4x3'), 'image.file.url')
      || get(video, 'thumbnailImage[0].image.file.url') || get(video, 'thumbnailImage[0]');

    // Configs
    const youtubeConfig = {
      playerVars: {
        controls: 1,
        rel: 0,
        color: 'white',
        disablekb: 1,
        modestbranding: 1,
        ...options,
      },
    };

    // If Youtube
    if (video.youtubeId != null) {
      return amp === true
        ? (
          <amp-youtube
            width="480"
            height="270"
            layout="responsive"
            data-videoid={video.youtubeId}
            data-param-rel="0"
          ></amp-youtube>
        ) : (
          <ReactPlayer
            width="100%"
            height="100%"
            url={`https://www.youtube.com/watch?v=${get(video, 'youtubeId')}`}
            light={thumbnailImage}
            config={{
              youtube: youtubeConfig,
            }}
            onPlay={() => {
              if (this.props.onPlay) this.props.onPlay();
            }}
          />
        );
    }

    // If Static Video
    if (get(video, 'video.file.url') != null) {
      return amp === true
        ? (
          <amp-video
            width="480"
            height="270"
            layout="responsive"
            src={get(video, 'video.file.url')}
            poster={thumbnailImage}
          ></amp-video>
        ) : (
          <ReactPlayer
            width="100%"
            height="100%"
            url={get(video, 'video.file.url', '').includes('http')
              ? get(video, 'video.file.url')
              : `https://www.youtube.com/watch?v=${get(video, 'video.file.url')}`}
            light={thumbnailImage}
            config={{
              youtube: youtubeConfig,
            }}
            onPlay={() => {
              if (this.props.onPlay) this.props.onPlay();
            }}
          />
        );
    }
    // No video provided
    return null;
  }
}

export default withAmp(VideoInContext);
